import $ from 'jquery'

onDomLoad(function ($dom) {
  $dom.on('click', '.dependents-tree-wrapper', function () {
    const $dependenciesTree = $(this).find(
      "[data-behaviour='dependencies-tree']"
    )

    if ($dependenciesTree.text().length === 0) {
      $dependenciesTree.each(function () {
        const $this = $(this)

        Silverfin.Spinner.start()
        $.ajax({
          url: $this.data('url'),
          dataType: 'json',
          success: (treeData) => {
            generateTreeDiagram($this[0], treeData)
            Silverfin.Spinner.success()
          },
        })
      })
    }
  })

  function generateTreeDiagram(htmlElement, treeData) {
    // ************** Generate the tree diagram	 *****************
    const margin = { top: 0, right: 180, bottom: 0, left: 180 },
      width = 1300 - margin.left - margin.right,
      height = 1200 - margin.top - margin.bottom,
      halfWidth = width / 2
    // Collapse by default from level 1 on
    const collapingLimit = 1

    let i = 0,
      root = null
    const duration = 750

    const getChildren = (d) => {
      d.dependees && d.dependees.forEach((item) => (item.isRight = false))
      d.dependents && d.dependents.forEach((item) => (item.isRight = true))
      const a = (d.dependees || []).concat(d.dependents || [])
      a.forEach((item) => (item.parent = d))
      return a.length ? a : null
    }

    const connector = (d, _i) => {
      const source = calcLeft(d.source)
      const target = calcLeft(d.target)
      let hy = (target.y - source.y) / 2
      if (d.data && d.data.isRight) hy = -hy
      return `M${source.y},${source.x}H${source.y + hy}V${target.x}H${target.y}`
    }

    const calcLeft = (d) => {
      let l = d.y
      if (!(d.data && d.data.isRight)) l = width - d.y
      return { x: d.x, y: l }
    }

    const rebuildChildren = (node, level = 0) => {
      const children = getChildren(node)

      node.children = children

      if (children)
        children.forEach((child) => rebuildChildren(child, level + 1))
    }

    const rebuildCollapsedNodes = (node, level = 0) => {
      if (level >= collapingLimit) {
        node.data.collapsedChildren = node.children
        node.children = null
      }

      if (node.children)
        node.children.forEach((child) =>
          rebuildCollapsedNodes(child, level + 1)
        )
    }

    $(htmlElement).empty()
    const htmlWrapper = d3.select(htmlElement)
    // Define the SVG
    const svg = htmlWrapper
      .append('svg')
      .attr('width', width + margin.right + margin.left)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

    // Define the div for the tooltip
    const tooltip = htmlWrapper
      .append('div')
      .attr('class', 'd3-tooltip sf-bg-primary-subtle')
      .style('opacity', 0)

    root = treeData[0]
    const treemap = d3.tree().size([height, width])

    rebuildChildren(root)
    root.isRight = false
    const treeHierarchy = d3.hierarchy(root)

    rebuildCollapsedNodes(treeHierarchy)

    treeHierarchy.x0 = height / 2
    treeHierarchy.y0 = width / 2

    update(treeHierarchy)

    function update(source) {
      // Compute the new tree layout.
      const treeData = treemap(treeHierarchy)
      const nodes = treeData.descendants()
      const links = treeData.links()

      // Normalize for fixed-depth.
      nodes.forEach((d) => {
        d.y = d.depth * 260 + halfWidth
      })

      // Update the nodes…
      const node = svg
        .selectAll('g.node')
        .data(nodes, (d) => d.id || (d.id = ++i))

      // Enter any new nodes at the parent's previous position.
      const nodeEnter = node
        .enter()
        .append('g')
        .attr('class', 'node')
        .attr('transform', (d) => {
          const x = (d.parent && d.parent.x0) || source.x0,
            y = (d.parent && d.parent.y0) || source.y0
          return 'translate(' + y + ',' + x + ')'
        })
        .on('click', click)

      nodeEnter
        .append('circle')
        .attr('r', 10)
        .style('fill', (d) =>
          d.data.collapsedChildren ? 'lightsteelblue' : '#fff'
        )

      nodeEnter
        .append('text')
        .attr('dy', (d) => (d.data.isRight ? 17 : -11))
        .attr('text-anchor', 'middle')
        .text((d) => d.data.name)
        .on('mouseover', (d) => {
          tooltip.transition().duration(200).style('opacity', 0.9)
          tooltip
            .html(d.data.tooltip)
            .style('left', d3.event.pageX + 'px')
            .style('top', d3.event.pageY - 50 + 'px')
        })
        .on('mouseout', (_d) => {
          tooltip.transition().duration(3000).style('opacity', 0)
        })

      const nodeUpdate = nodeEnter.merge(node)

      // Transition nodes to their new position.
      nodeUpdate
        .transition()
        .duration(duration)
        .attr('transform', (d) => {
          const p = calcLeft(d)
          return 'translate(' + p.y + ',' + p.x + ')'
        })

      nodeUpdate
        .select('circle')
        .attr('r', 6.5)
        .style('fill', (d) =>
          d.data.collapsedChildren ? 'lightsteelblue' : '#fff'
        )

      nodeUpdate.select('text').style('fill-opacity', 1)

      // Transition exiting nodes to the parent's new position.
      const nodeExit = node
        .exit()
        .transition()
        .duration(duration)
        .attr('transform', (d) => {
          const p = calcLeft(d.parent || source)
          return 'translate(' + p.y + ',' + p.x + ')'
        })
        .remove()

      nodeExit.select('circle').attr('r', 1e-6)

      nodeExit.select('text').style('fill-opacity', 1e-6)

      // Update the links...
      const link = svg.selectAll('path.link').data(links, (d) => d.target.id)

      // Define arrow
      svg
        .append('svg:defs')
        .append('svg:marker')
        .attr('id', 'right-arrow')
        .attr('viewBox', '0 -5 10 10')
        .attr('refX', 18)
        .attr('markerWidth', 5)
        .attr('markerHeight', 5)
        .attr('orient', 'auto-start-reverse')
        .append('svg:path')
        .attr('d', 'M0,-5L10,0L0,5')
        .attr('fill', '#ccc')

      // Enter any new links at the parent's previous position.
      const linkEnter = link
        .enter()
        .insert('path', 'g')
        .attr('class', 'link')
        .attr('marker-start', (d) =>
          d.target.data.isRight ? null : 'url(#right-arrow)'
        )
        .attr('marker-end', (d) =>
          d.target.data.isRight ? 'url(#right-arrow)' : null
        )
        .attr('d', (d) => {
          const x = (d.source && d.source.x0) || source.x0,
            y = (d.source && d.source.y0) || source.y0
          const o = calcLeft({ x: x, y: y })
          return connector({ source: o, target: o })
        })

      const linkUpdate = linkEnter.merge(link)

      // Transition links to their new position.
      linkUpdate.transition().duration(duration).attr('d', connector)

      // Transition exiting nodes to the parent's new position.
      link
        .exit()
        .transition()
        .duration(duration)
        .attr('d', (d) => {
          const o = calcLeft(d.source || source)
          return connector({ source: calcLeft(o), target: calcLeft(o) })
        })
        .remove()

      // Stash the old positions for transition.
      nodes.forEach((d) => {
        const p = calcLeft(d)
        d.x0 = p.x
        d.y0 = p.y
      })

      // Toggle children on click.
      function click(d) {
        if (d.children) {
          d.data.collapsedChildren = d.children
          d.children = null
        } else {
          d.children = d.data.collapsedChildren
          d.data.collapsedChildren = null
        }
        update(source)
      }
    }
  }
})
